import { toast, type ToastOptions } from 'react-toastify';

const shownToastKeys = new Set<string>();

/** Show a toast at most once per page session for a given key. */
export function toastOnce(
  key: string,
  show: (message: string, options?: ToastOptions) => void,
  message: string,
  options?: ToastOptions
): void {
  if (shownToastKeys.has(key)) {
    return;
  }
  shownToastKeys.add(key);
  show(message, options);
}

export function toastSuccessOnce(key: string, message: string, options?: ToastOptions): void {
  toastOnce(key, toast.success, message, options);
}

export function toastErrorOnce(key: string, message: string, options?: ToastOptions): void {
  toastOnce(key, toast.error, message, options);
}

export function toastInfoOnce(key: string, message: string, options?: ToastOptions): void {
  toastOnce(key, toast.info, message, options);
}
